import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import { Gtag } from 'angular-gtag';
import { Observable, withLatestFrom } from 'rxjs';
import { AuthenticatedUser } from '../core/models';
import { UpdatePassword } from '../core/store/user/user.actions';
import { UserState } from '../core/store/user/user.state';
import { ApiStoreData } from '../core/store/utils';
import { passwordMatchValidator, passwordValidator, validateAllFormFields } from '../core/utils/validators';
import { asFormControl } from '../core/utils/common';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
})
export class AccountComponent {
  @Select(UserState.authenticatedUser) authenticatedUser$!: Observable<AuthenticatedUser | null>;
  @Select(UserState.updatePasswordState) updatePasswordState$!: Observable<ApiStoreData<null>>;

  successMessage: string | null = null;
  errorMessage: string | null = null;

  changePasswordForm = new FormGroup(
    {
      currentPassword: new FormControl(null, Validators.required),
      newPassword: new FormControl(null, [Validators.required, passwordValidator()]),
      repeatPassword: new FormControl(null, Validators.required),
    },
    [passwordMatchValidator('newPassword', 'repeatPassword')]
  );
  asFormControl = asFormControl;

  constructor(private store: Store, private gtag: Gtag) {}

  onSubmitChangePassword() {
    this.successMessage = null;
    this.errorMessage = null;

    if (!this.changePasswordForm.valid) {
      validateAllFormFields(this.changePasswordForm);
      return;
    }

    this.gtag.event('user_account_update_password', {
      event_category: 'engagement',
    });

    this.store
      .dispatch(new UpdatePassword(this.changePasswordForm.value))
      .pipe(withLatestFrom(this.updatePasswordState$))
      .subscribe(([_, state]) => {
        if (state.isFinished && state.error) {
          this.errorMessage =
            'Failed to update your password. Please ensure the current password is correct and that the new password is not the same as the current password.';
        } else {
          this.changePasswordForm.reset();
          this.successMessage = 'Your pasword was updated successfully.';
        }
      });
  }

  onCancelChangePassword() {
    this.changePasswordForm.reset();
    this.successMessage = null;
    this.errorMessage = null;
  }
}
